module.exports = Function.call.bind(Object.prototype.hasOwnProperty);



/** WEBPACK FOOTER **
 ** ./~/prop-types/lib/has.js
 **/